import { css } from 'lit'

// Figma `02 / Controls`（326:19169）。此檔只放控制項本身的長相 —— 尺寸、圓角、字級、配色與
// 互動狀態。「這顆按鈕在版面裡佔多寬、排在哪、什麼時候換行」屬於版型，留在各自的版型檔
// （action bar 在 active.ts、致謝畫面在 results.ts、收合卡在 sidebar-shell.ts）。
//
// 設計稿的 Primary Button 是 `Type(Fill|Outline) × Size(S|M|L) × State(Default|Hover|Pressed|Disabled)`
// 的參數化元件。SDK 只用到 Fill 與 Outline 各自的 L 與 M：
//   - `.btn-primary` = Type=Fill，`.btn-secondary` = Type=Outline
//   - Size=L（48 高、radius 20）是此檔的預設，三個使用處都吃這個
//   - Size=M（40 高、radius 12）只有手機版的 action bar 需要，故降級規則寫在 active.ts 的
//     container query 裡並 scope 在 `.nav` 內 —— 致謝鈕與收合卡的 CTA 在窄容器也維持 L
//     （Figma 322:5348、166:2094 皆為 48）
//   - Size=S（96×28）與 Text Button（92:753）目前沒有畫面用到，需要時再補
export const controlStyles = css`
  /* 高度直接指定而不是靠 padding 與 line box 相加：設計稿的 48 / 40 含 outline 的 1px 邊框，
     交給內容去撐會讓 outline 版比 fill 版高 2px，再經 flex 容器的 align-items:stretch
     把同一列的 fill 版一起拉高。 */
  .btn-primary,
  .btn-secondary {
    display: flex;
    box-sizing: border-box;
    height: 48px;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 12px 20px;
    border-radius: 20px;
    font: inherit;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1.2px;
    cursor: pointer;
  }
  /* Type=Fill（42:20 系列）：brand 底、反白粗體字。hover / pressed 疊一層半透明灰
     —— 用 linear-gradient 疊色而非 color-mix()，後者 Safari 16 沒有（見 browser baseline）。 */
  .btn-primary {
    border: none;
    background: var(--mp-brand);
    color: var(--mp-text-inverse);
    transition: background 0.15s;
  }
  .btn-primary:hover:not(:disabled) {
    background: linear-gradient(var(--mp-btn-hover), var(--mp-btn-hover)), var(--mp-brand);
  }
  .btn-primary:active:not(:disabled) {
    background: linear-gradient(var(--mp-btn-pressed), var(--mp-btn-pressed)), var(--mp-brand);
  }
  .btn-primary:disabled {
    background: var(--mp-btn-disabled);
    color: var(--mp-text-muted);
    cursor: not-allowed;
  }
  /* Type=Outline（92:736 系列）：brand 邊框 + brand 字，hover / pressed 填半透明灰。 */
  .btn-secondary {
    border: 1px solid var(--mp-brand);
    background: transparent;
    color: var(--mp-brand);
  }
  .btn-secondary:hover { background: var(--mp-btn-hover); }
  .btn-secondary:active { background: var(--mp-btn-pressed); }
`
